// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"be9bdf2f","958":"696fbf16"}[chunkId] + ".chunk.js";
};